export const defaultIcon = 'icon-folder';
export const defaultColor = '#000';
